import React from 'react';

const Terms = (props) => {
    const { onChange, accepts, termsError } = props;
    const termsUrl = 'https://info.tradera.com/sakerhetscenter/anvandaravtal/';
    const privacyUrl =
        'https://info.tradera.com/sakerhetscenter/integritetspolicy/';

    return (
        <div>
            <div className={`form-check ${termsError ? 'mb-0' : ''}`}>
                <input
                    type="checkbox"
                    id="terms_integrity"
                    className="form-check-input"
                    onChange={(e) => onChange(e.target.checked)}
                    defaultChecked={accepts}
                />
                <label htmlFor="terms_integrity" className="form-check-label">
                    <span>
                        Jag accepterar{' '}
                        <a
                            href={termsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="link ">
                            Traderas användaravtal
                        </a>{' '}
                        och{' '}
                        <a
                            href={privacyUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="link">
                            integritetspolicy
                        </a>
                        .
                    </span>
                </label>
            </div>
            {termsError && (
                <div className="text-left text-danger mb-1">
                    Du måste godkänna användaravtalet
                </div>
            )}
        </div>
    );
};

export default Terms;
